export default __webpack_public_path__ + "static/Chart-2-Mobile-eb2b3b7c50d68c55bbef0cbcba4a714e.webp";